import React from 'react';
import './HeroSection.css';
import CustomParticleAnimation from './CustomParticleAnimation'; 

const HeroSection = () => {
  const handleButtonClick = () => {
    // Replace with the actual link to the projects page
    window.location.href = '/projects';
  };

  return (
    <div className="hero-section">
      <div className="content">
        <h1 className="title">We are best at what we do</h1>
        <p className="subtitle">We are a full-service video production company offering gear rental and travel coordination to bring your vision to life. As a leading film production house in Jaipur and a trusted production house in Rajasthan, we deliver high-quality results from start to finish.</p>
        <button className="projects-button" onClick={handleButtonClick}>
          View Projects
        </button>
      </div>
      
      {/* Custom particle animation container placed below the content */}
      <div className="particle-animation-container">
        <CustomParticleAnimation />
      </div>
    </div>
  );
};

export default HeroSection;
